/* Template 8: scoped presentational utilities. No cart submission or Zepto values are intercepted. */
(() => {
  'use strict';
  if (window.mgT8RefinementsLoaded) return;
  window.mgT8RefinementsLoaded = true;
  const instances = new WeakMap();
  const selector = '.mg-template8[data-mg-layout="2"]';
  function initialise(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const {signal} = controller;
    const information = root.querySelector('.mg-t8-information');
    const form = root.querySelector('.mg-t8-form');
    const media = root.querySelector('.mg-t8-media');
    const afterpay = root.querySelector('[data-mg-t8-afterpay]');
    const amount = root.querySelector('[data-mg-t8-instalment]');
    let product = null;
    try { product = JSON.parse(document.getElementById(`ProductJson-${root.dataset.sectionId}`)?.textContent || 'null'); } catch (_) {}
    let geometryFrame = 0, cleanupFrame = 0, priceTimer = 0, bindTimer = 0, boundJQuery = null, bindAttempts = 0;
    const headerNodes = Array.from(document.querySelectorAll('#shopify-section-announcement-bar, #shopify-section-header-1, .site-header, .site-header--sticky'));
    function updateGeometry() {
      geometryFrame = 0;
      if (!media || root.dataset.mgStickyGallery !== 'true' || innerWidth <= 900) return;
      let headerBottom = 0;
      headerNodes.forEach(node => {
        const style = getComputedStyle(node), rect = node.getBoundingClientRect();
        if ((style.position === 'fixed' || style.position === 'sticky') && style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0 && rect.bottom > 0 && rect.top < Math.min(240, innerHeight / 2)) {
          headerBottom = Math.max(headerBottom, Math.min(rect.bottom, innerHeight / 2));
        }
      });
      // Tall images scroll naturally until their bottom fits, instead of being cropped.
      const top = Math.round(Math.min(headerBottom + 16, innerHeight - media.getBoundingClientRect().height - 16));
      const value = `${top}px`;
      if (root.style.getPropertyValue('--mg-t8-sticky-top') !== value) root.style.setProperty('--mg-t8-sticky-top', value);
    }
    function scheduleGeometry() { if (!geometryFrame) geometryFrame = requestAnimationFrame(updateGeometry); }
    const exactAddonLabel = /^add[\s\u00a0-]*ons?\s*:?$/i;
    function removeAddonHeading() {
      cleanupFrame = 0;
      if (!information) return;
      information.querySelectorAll('.mg-t8-empty-addon-heading').forEach(node => {
        if (node.textContent.trim() && !exactAddonLabel.test(node.textContent.trim())) node.classList.remove('mg-t8-empty-addon-heading');
      });
      const walker = document.createTreeWalker(information, NodeFilter.SHOW_TEXT);
      const matches = [];
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement?.closest('script,style,textarea,option,.mg-t8-details')) continue;
        if (exactAddonLabel.test((node.nodeValue || '').trim())) matches.push(node);
      }
      matches.forEach(text => {
        const parent = text.parentElement;
        text.nodeValue = '';
        // Never hide the app container or its controls, only an empty heading element.
        if (parent && /^(H[1-6]|P|SPAN|DIV)$/.test(parent.tagName) && parent.childElementCount === 0 && !parent.textContent.trim()) parent.classList.add('mg-t8-empty-addon-heading');
      });
    }
    const headingObserver = new MutationObserver(() => {
      if (!cleanupFrame) cleanupFrame = requestAnimationFrame(removeAddonHeading);
    });
    if (information) {
      removeAddonHeading();
      headingObserver.observe(information, {childList:true, subtree:true, characterData:true});
    }
    function updateAfterpay(variant) {
      if (!afterpay || !amount) return;
      if (!variant) {
        const id = form?.querySelector('[name="id"]')?.value;
        variant = product?.variants?.find(item => String(item.id) === String(id));
      }
      if (!variant || !Number.isFinite(Number(variant.price)) || Number(variant.price) <= 0) { afterpay.hidden = true; return; }
      const currency = afterpay.dataset.currency || 'AUD';
      const cents = Math.round(Number(variant.price) / 4);
      const value = new Intl.NumberFormat('en-AU', {style:'currency', currency, minimumFractionDigits:2, maximumFractionDigits:2}).format(cents / 100);
      if (amount.textContent !== value) amount.textContent = value;
      afterpay.hidden = false;
    }
    function bindVariantEvent() {
      if (signal.aborted) return;
      if (!window.jQuery) { if (++bindAttempts < 50) bindTimer = setTimeout(bindVariantEvent, 100); return; }
      boundJQuery = window.jQuery;
      boundJQuery(root).on('variantChange.mgT8Refinements', event => updateAfterpay(event.variant));
    }
    form?.addEventListener('change', () => { clearTimeout(priceTimer); priceTimer = setTimeout(() => updateAfterpay(), 0); }, {signal});
    root.addEventListener('click', event => {
      const tab = event.target instanceof Element && event.target.closest('[data-mg-t8-tab]');
      if (tab && root.contains(tab)) activateTab(tab);
    }, {signal});
    function activateTab(tab) {
      const group = tab.closest('[data-mg-t8-details]');
      group.querySelectorAll('[data-mg-t8-tab]').forEach(button => {
        const selected = button === tab;
        button.setAttribute('aria-selected', String(selected)); button.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
    }
    root.addEventListener('keydown', event => {
      const tab = event.target instanceof Element && event.target.closest('[data-mg-t8-tab]');
      if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      const tabs = Array.from(tab.closest('[role="tablist"]').querySelectorAll('[data-mg-t8-tab]'));
      let index = tabs.indexOf(tab);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = tabs.length - 1;
      else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      event.preventDefault(); activateTab(tabs[index]); tabs[index].focus();
    }, {signal});
    const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(scheduleGeometry) : null;
    [media, ...headerNodes].filter(Boolean).forEach(node => resizeObserver?.observe(node));
    window.addEventListener('scroll', scheduleGeometry, {passive:true, signal});
    window.addEventListener('resize', scheduleGeometry, {passive:true, signal});
    window.addEventListener('pageshow', scheduleGeometry, {signal});
    scheduleGeometry(); bindVariantEvent();
    instances.set(root, () => {
      controller.abort(); headingObserver.disconnect(); resizeObserver?.disconnect();
      cancelAnimationFrame(geometryFrame); cancelAnimationFrame(cleanupFrame);
      clearTimeout(priceTimer); clearTimeout(bindTimer);
      boundJQuery?.(root).off('.mgT8Refinements'); instances.delete(root);
    });
  }
  function within(scope, callback) {
    if (scope.matches?.(selector)) callback(scope);
    scope.querySelectorAll(selector).forEach(callback);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => within(document, initialise), {once:true});
  else within(document, initialise);
  document.addEventListener('shopify:section:load', event => within(event.target, initialise));
  document.addEventListener('shopify:section:unload', event => within(event.target, root => instances.get(root)?.()));
})();
